import { useCurrentLocale, useCurrentLocaleDirection } from '@ms/yammer-i18n-react';
import { useSetRTL } from '@ms/yammer-web-core-ui/dist/util/useSetRTL';
import type { FC } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const AppDocumentLanguage: FC = () => {
  const lang = useCurrentLocale();
  const dir = useCurrentLocaleDirection();
  useSetRTL(dir);
  const productName = 'Viva Engage';

  return (
    <Helmet defaultTitle={productName} titleTemplate={`${productName} - %s`} defer={false}>
      <html lang={lang} dir={dir} />
    </Helmet>
  );
};
